import { Pipe, PipeTransform } from '@angular/core';
import { BILL_FREQUENCY_TYPES, BillFrequencyType } from '../enums/bill-frequency-type';

@Pipe({
  name: 'readableBillFrequency'
})
export class ReadableBillFrequencyPipe implements PipeTransform {

  public transform(value: BillFrequencyType): string {
    if (!value) {
      return '';
    }

    const billFrequencyType = BILL_FREQUENCY_TYPES.find(status => status.value === value);

    if (!billFrequencyType) {
      // Return the passed value
      return value;
    }

    return billFrequencyType.label;
  }

}
